import { render, staticRenderFns } from "./RolChip.vue?vue&type=template&id=5d7c94dc&"
import script from "./RolChip.vue?vue&type=script&lang=js&"
export * from "./RolChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QChip,QAvatar,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QChip,QAvatar,QImg})
